import axios from "axios";

// Get API URL from runtime configuration or fallback to build-time env var
const getApiUrl = () => {
  const fromWindow = typeof window !== "undefined" && window.REACT_APP_API_URL;
  const fromEnv = process.env.REACT_APP_API_URL;
  const url = fromWindow || fromEnv || "http://localhost:5001";
  return typeof url === "string" && url.trim()
    ? url.trim()
    : "http://localhost:5001";
};

// Create axios instance with environment-based base URL
const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

console.log("API instance created with baseURL:", api.defaults.baseURL);
console.log("API instance config:", api.defaults);

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    console.log("API request to:", config.baseURL + config.url);
    console.log("Request method:", config.method);
    console.log("Request data:", config.data);
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log("API response received:", response.status, response.data);
    return response;
  },
  (error) => {
    console.error(
      "API response error:",
      error.response?.status,
      error.response?.data,
    );
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
